import layout from '@/views/layout/layout.vue'
const helpAwardTotalList = r => require.ensure([], () => r(require('@/views/marketing/helpAwardTotal/list.vue')), 'group-marketing-helpAwardTotal')

const helpAwardTotalActivity = [
  {
    path: '/marketing/helpAwardTotal',
    name: 'marketing-helpAwardTotal',
    component: layout,
    redirect: '/marketing/helpAwardTotal/list',
    hidden: true,
    children: [
      {
        path: 'list',
        component: helpAwardTotalList,
        name: 'marketing-helpAwardTotal-list',
        meta: {
          displayName: '助力活动管理',
          requireAuth: true
        }
      }
    ]
  }
]

export default helpAwardTotalActivity



// WEBPACK FOOTER //
// ./src/router/marketing/HelpAwardTotal.js